import React, { PropsWithChildren, ReactNode } from 'react';

interface NoSsrProps extends PropsWithChildren {
  fallback?: ReactNode;
}

const NoSsr: React.FC<NoSsrProps> = ({ children, fallback = null }) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useLayoutEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? children : fallback;
};

export default NoSsr;
